import React from 'react';
import {Typography} from 'lark';
import {Location} from 'history';
import {parseUrl} from '~/utils/url';
import './index.less';

const scanQR = require('@/public/assets/qrcode/扫码.png');
const scanQR2x = require('@/public/assets/qrcode/扫码@2x.png');
const scanQR3x = require('@/public/assets/qrcode/扫码@3x.png');

interface QRLogin {
    location: Location;
}

interface ErrorType {
    QS000001: 'APP_NOT_SUPPORT';
    QS000002: 'CODE_INVALID';
}

type ErrorMsgKeys = ErrorType[keyof ErrorType];
type ErrorMsg = {
    [key in ErrorMsgKeys]: string;
}

const {Paragraph} = Typography;

const ERROR_TYPE: ErrorType = {
    QS000001: 'APP_NOT_SUPPORT',
    QS000002: 'CODE_INVALID',
};

const ERROR_MSG: ErrorMsg = {
    APP_NOT_SUPPORT: '请使用“企业微信”或“灵犀”扫码',
    CODE_INVALID: '二维码已失效, 请重新扫码',
};

const QRLoginError = (props: QRLogin) => {
    const {location: {search}} = props;
    // eslint-disable-next-line
    const queries: any = parseUrl(search);
    const {code: type}: {code: keyof ErrorType} = queries;
    return (
        <div className="qr-error">
            <div className="qr-error-img-wrapper">
                <img
                    className="qr-error-img"
                    srcSet={`${scanQR}, ${scanQR2x} 2x, ${scanQR3x} 3x,`}
                    src={scanQR3x}
                    alt="扫码"
                />
            </div>
            <Paragraph>
                {ERROR_MSG[ERROR_TYPE[type]] || '未知错误'}
            </Paragraph>
        </div>
    );
};

export default QRLoginError;
